export enum DeliveryType {
  Address,
  Fax,
  Email,
}

export default DeliveryType;
